import Client from './Client';

export const AiChatApi = {
    send: async (message) => {
        return await Client.post('/v1/ai/chat', { message });
    },
    reset: async () => {
        return await Client.post('/v1/ai/chat/reset');
    },
};

export default AiChatApi;
